import React from 'react';
import { PublicLayout } from '@/components/Layout/PublicLayout';

export const TermsConditionsPage: React.FC = () => {
  return (
    <PublicLayout
      title="Terms & Conditions"
    >
      <div className="space-y-6 text-sm sm:text-base text-slate-700 leading-relaxed">
        
        {/* Section 1 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            1. Using the App
          </h3>
          <p>
            You agree to provide accurate information when creating an account or placing an order. You are responsible for keeping your account information secure.
          </p>
        </section>

        {/* Section 2 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            2. Products and Availability
          </h3>
          <p>
            Products are subject to availability. We make reasonable efforts to keep product information, descriptions and prices accurate.
          </p>
        </section>

        {/* Section 3 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            3. Prices
          </h3>
          <p>
            The price and order total will be shown before you confirm your purchase. Prices may change from time to time.
          </p>
        </section>

        {/* Section 4 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            4. Orders
          </h3>
          <p>
            When you place an order, you are requesting to purchase the selected products. Orders may be affected by stock availability, payment issues or obvious pricing or system errors.
          </p>
        </section>

        {/* Section 5 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            5. Payment
          </h3>
          <p>
            Payment must be made using the payment methods available through the App. Where advance payment is required, an order may only be processed after successful payment authorisation.
          </p>
        </section>

        {/* Section 6 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            6. Delivery
          </h3>
          <p>
            Customers must provide accurate delivery information. Delivery times are estimates unless otherwise stated and may be affected by circumstances outside Yebo Eggs' reasonable control.
          </p>
        </section>

        {/* Section 7 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            7. Order Tracking
          </h3>
          <p>
            Where tracking is available, customers can view the status of their order through the App.
          </p>
        </section>

        {/* Section 8 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            8. Cancellation, Returns and Refunds
          </h3>
          <p>
            These are handled in accordance with the Yebo Eggs Cancellation, Returns & Refund Policy and applicable South African law.
          </p>
        </section>

        {/* Section 9 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            9. Customer Responsibilities
          </h3>
          <p>
            You may not misuse the App, provide false information, attempt unauthorised access, use the App for fraudulent purposes or use the App for unlawful activities.
          </p>
        </section>

        {/* Section 10 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            10. Privacy
          </h3>
          <p>
            Your use of the App is also subject to the Yebo Eggs Privacy Policy.
          </p>
        </section>

        {/* Section 11 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            11. Third-Party Services
          </h3>
          <p>
            The App may use third-party services such as payment, delivery, mapping, hosting and technology providers.
          </p>
        </section>

        {/* Section 12 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            12. Changes to These Terms
          </h3>
          <p>
            Yebo Eggs may update these Terms from time to time. The latest version will be made available through the App.
          </p>
        </section>

        {/* Section 13 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            13. Governing Law
          </h3>
          <p>
            These Terms are governed by the laws of the Republic of South Africa. Nothing in these Terms is intended to remove or limit rights that cannot lawfully be excluded.
          </p>
        </section>

        {/* Section 14 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            14. Contact
          </h3>
          <p>
            For questions, complaints or assistance, use the Yebo Eggs contact details provided in the App.
          </p>
        </section>

      </div>
    </PublicLayout>
  );
};
